"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Service_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Service = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const events_1 = require("../events");
const contact_profile_enum_1 = require("./contact-profile-enum");
const opportunity_service_1 = require("./opportunity-service");
const rejected_service_1 = require("./rejected-service");
const service_sortings_1 = require("./service-sortings");
const base_normalized_service_1 = require("./base-normalized-service");
let Service = Service_1 = class Service extends base_normalized_service_1.BaseNormalizedService {
};
Service.EVENTS = (0, events_1.makeEventsForClass)(Service_1);
Service.NAME_GENERATED_PREFIX = 'SVC';
Service.SFID_PREFIX = 'a1t';
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.PrimaryColumn)('character varying', {
        nullable: false,
        length: 18,
        name: 'sfid',
        default: () => "gid_generate_sfid('a1t')",
    }),
    __metadata("design:type", String)
], Service.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], Service.prototype, "apiId", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        name: 'name_generated',
        length: 80,
        default: () => "gid_generate_name('SVC', 10)",
        unique: true,
    }),
    __metadata("design:type", String)
], Service.prototype, "nameGenerated", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp without time zone',
        nullable: false,
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], Service.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
        nullable: true,
    }),
    __metadata("design:type", Date)
], Service.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'varchar',
        nullable: true,
        length: 18,
        name: 'normalized_service__c',
    }),
    __metadata("design:type", String)
], Service.prototype, "normalizedService", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('service_families'),
    (0, typeorm_1.Column)('character varying', {
        name: 'service_familie__c',
        length: 255,
    }),
    __metadata("design:type", String)
], Service.prototype, "serviceFamily", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_active__c',
        nullable: true,
        default: true,
    }),
    __metadata("design:type", Boolean)
], Service.prototype, "isActive", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_remote__c',
        nullable: true,
        default: false,
    }),
    __metadata("design:type", Boolean)
], Service.prototype, "isRemote", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'async_appointment__c',
        nullable: true,
        default: false,
    }),
    __metadata("design:type", Boolean)
], Service.prototype, "asyncAppointment", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_customer_sign_required__c',
        default: true,
    }),
    __metadata("design:type", Boolean)
], Service.prototype, "isCustomerSignRequired", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_planning__c',
        nullable: true,
        default: false,
    }),
    __metadata("design:type", Boolean)
], Service.prototype, "isPlanning", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'opportunity__c',
    }),
    __metadata("design:type", String)
], Service.prototype, "opportunity", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        name: 'planning_service__c',
        length: 255,
    }),
    __metadata("design:type", String)
], Service.prototype, "serviceType", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => opportunity_service_1.OpportunityService, (opSvc) => opSvc.overridesService),
    __metadata("design:type", Array)
], Service.prototype, "opportunityServices", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM, layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.OneToMany)(() => service_sortings_1.ServiceSortings, (serviceSortings) => serviceSortings.service),
    __metadata("design:type", Array)
], Service.prototype, "serviceSortings", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM, layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.OneToMany)(() => rejected_service_1.RejectedService, (rejectedServices) => rejectedServices.service),
    __metadata("design:type", Array)
], Service.prototype, "rejectedServices", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValuesFromPicklist('invoicetarget'),
    (0, typeorm_1.Column)('varchar', {
        name: 'invoicing_target__c',
        nullable: false,
        length: 255,
    }),
    __metadata("design:type", String)
], Service.prototype, "invoicingTarget", void 0);
Service = Service_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Normalized Service',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('srvice__c', { schema: 'public', synchronize: true })
], Service);
exports.Service = Service;
//# sourceMappingURL=service.js.map